import { f as e } from "./for_each_object.js";
var f = e, m = function(a, o) {
  var r = [];
  return f(a, function(t, c) {
    r.push(o(t, c));
  }), r;
};
export {
  m
};
